import createAxios from './../../axiosHttps';

export const brandAdminService = {
  getBrands,
  
  insertBrand,
  
  
  
  
  getCustomers,getClientById,newClient,updateClient
};

const axiosInstance = createAxios();

function buildQueryUrl(basePath, query = {}) {
  const url = new URL(basePath, window.location.origin);
  const params = new URLSearchParams();

  // Agregar los parámetros a la URL
  Object.keys(query).forEach(key => {
      if (query[key] !== undefined && query[key] !== null) {
          params.append(key, query[key]);
      }
  });

  // Devolver la URL completa
  url.search = params.toString();
  return url.pathname + url.search;
}

async function getBrands(filters, pagination) {
  const query = {
    page: pagination ? pagination.currentPage - 1 : 0,
    limit: pagination ? pagination.rows : 20,
    search: filters?.search,
    status: filters?.status,
    sort: filters?.sort?.sort ? filters?.sort?.sort : '_id',
    order: filters?.sort?.order ? filters?.sort?.order : 'ascending',
    //warehouse: filters?.warehouse
  };
  
  const urlPath = buildQueryUrl(`/administration/brands`, query);
  return await axiosInstance.get(urlPath).catch(handleError);
}

async function insertBrand(payload) {    
  const urlPath = buildQueryUrl(`/administration/brands`);
  return await axiosInstance.post(urlPath, payload).catch(handleError);
}


function handleError(error) {
  console.error('API call failed:', error);
  throw axiosInstance;
}


function getCustomers(pagination,filters) {
  const axios = createAxios();
  let urlPath = 'administration/customer';
  if (pagination) {
    urlPath += `?page=${pagination.currentPage - 1}&limit=${pagination.rows}`;
  } else {
    urlPath += '?page=0&limit=500';
  }
  if (filters && filters.search) {
      urlPath += `&search=${encodeURIComponent(filters.search)}`;
  }
  if (filters && filters.sort) {
    if(filters.sort.sort){
        urlPath += `&sort=${filters.sort.sort}`;
    }
    if(filters.sort.order){
        urlPath += `&order=${filters.sort.order}`;
    }
  }
  return axios.get(urlPath);
}
function getClientById(id){
  const axios = createAxios();
  let urlPath = `administration/customer/${id}`;
  return axios.get(urlPath);
}
function newClient(body){
  const axios = createAxios();
  let urlPath = `administration/customer`;
  return axios.post(urlPath, body);
}
function updateClient(body, id){
  const axios = createAxios();
  let urlPath = `administration/customer/${id}`;
  return axios.put(urlPath, body);
}
